export const getItemPositionInTheCart = itemIndex => itemIndex + 1;